import { useEffect, useState } from "react";
import ProductionPlanDetails from "./ProductionPlanDetails";
import PlanSetup from "./PlanSetup";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  clearProductionState,
  setProductionPreviousPlan,
} from "../../services/productionPlanSlice";
import { useLocation } from "react-router-dom";

const ProductionPlan = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const location = useLocation();
  const previousPlan = location?.pathname?.includes("previous");
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (): void => {
    setOpen(true);
  };

  const handleFilterChange = (): void => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(setProductionPreviousPlan(previousPlan));
    return () => {
      dispatch(clearProductionState());
    };
  }, [location?.pathname]);

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        {previousPlan ? "Previous Production Plan" : "Production Plan"}
      </h1>
      <PlanSetup
        handleClick={handleClick}
        handleFilterChange={handleFilterChange}
      />
      {open && <ProductionPlanDetails />}
    </div>
  );
};

export default ProductionPlan;
